import { kebabCase } from 'lodash-es';

export class Formatter {
  static currency(input: number | null, maximumFractionDigits = 0) {
    if (Formatter.isNullOrNaN(input)) {
      return 'N/A';
    }

    return new Intl.NumberFormat('en-US', {
      currency: 'USD',
      maximumFractionDigits,
      style: 'currency',
    }).format(input as number);
  }

  // Why not simply have an percent pipe and reuse it here?
  static percent(input: number | null) {
    if (Formatter.isNullOrNaN(input)) {
      return 'N/A';
    }

    return new Intl.NumberFormat('en-US', { style: 'percent' }).format(
      Math.round(input as number) / 100,
    );
  }

  static number(input: number | null) {
    if (Formatter.isNullOrNaN(input)) {
      return 'N/A';
    }

    // Defaults for NumberFormat are much the same as the defaults for the old Angular decimalPipe:
    //   - minimumIntegerDigits: 1
    //   - maximumFractionDigits: 3
    return new Intl.NumberFormat('en-US').format(input as number);
  }

  // Why not simply have an kebabValue pipe and reuse it here?
  static kebabValue(value: string | null) {
    if (value) {
      return kebabCase(value);
    } else {
      return '';
    }
  }

  private static isNullOrNaN = (input: number | null) =>
    input === null || isNaN(input);
}
